import React from 'react'
import { Remarkable } from 'remarkable'

const md = new Remarkable({
  inline: true,
  breaks: true,
  html: false,
})
// Override the paragraph renderer to not wrap content in p tags
md.renderer.rules.paragraph_open = () => ''
md.renderer.rules.paragraph_close = () => ''

function PlanValueProp (props) {
  const {
    valueProp,
    className,
  } = props

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: md.render(valueProp) }}
    />
  )
}

export default PlanValueProp
